import React from 'react'
import { Skeleton } from '.'

type Props = {
  noAnimation?: boolean
}

export const ProductCardCompactSkeleton = ({ noAnimation = false }: Props) => {
  return (
    <Skeleton shade="light" className="d-flex u-mb-12 u-px-8 u-py-12" noAnimation={noAnimation}>
      <Skeleton className="u-mr-12" withLogo noAnimation={noAnimation} width={64} height={48} />

      <div>
        <Skeleton
          className="u-mb-4"
          shade="dark"
          width={50}
          height={10}
          noAnimation={noAnimation}></Skeleton>
        <Skeleton
          className="u-mb-4"
          shade="dark"
          width={170}
          height={14}
          noAnimation={noAnimation}></Skeleton>
        <Skeleton
          className="u-mb-4"
          shade="dark"
          width={170}
          height={14}
          noAnimation={noAnimation}></Skeleton>
      </div>
    </Skeleton>
  )
}
